import {ConversationDetails} from '@/types/conversationMessage';
import conversationsFetchers from '@/api/fetchers/conversations';
import useDataQuery from '@/hooks/use-data-query';

export const CONVERSATION_DETAILS_QUERY_KEY = 'conversationDetails';

function useConversationDetailsQuery(
  conversationId: string | null,
  brandId: string
) {
  const response = useDataQuery<ConversationDetails>({
    queryKey: [CONVERSATION_DETAILS_QUERY_KEY, conversationId, brandId],
    queryFn: () =>
      conversationsFetchers.conversationDetails(
        conversationId as string,
        brandId
      ),
    enabled: !!conversationId && !!brandId,
    refetchOnWindowFocus: true,
  });

  return {
    unreadMessagesCount: response.data?.unreadMessagesCount ?? 0,
    campaignConversations: response.data?.campaignConversations ?? [],
    isLoading: response.isLoading,
    firstUnreadMessage: response.data?.firstUnreadMessage
      ? response.data?.firstUnreadMessage
      : null,
  };
}

export default useConversationDetailsQuery;
